export default __webpack_public_path__ + "static/image3-9bc0ccbeab509a695a5796d982801280.gif";